/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/no-namespace */
import CARMO_CONST from '@/common/util/const';

namespace Util {
  /**
   * Metaのtitle,descriptionの設定
   * @export
   * @param {string} title
   * @param {string} description
   */
  export function setMeta(title: string, description: string): void {
    if (title) {
      document.title = title;
    }
    const desc = document.querySelector("meta[name='description']");
    if (desc) {
      desc.setAttribute('content', description);
    }
  }

  /**
   * Metaのrobotsを設定
   */
  export function setRobots(): void {
    let meta = document.querySelector('meta[name=\'robots\']');
    if (!meta) {
      meta = document.createElement('meta');
      document.head.appendChild(meta);
      meta.setAttribute('name', 'robots');
    }
    meta.setAttribute('content', 'noindex');
  }
  /**
   * Metaのrobotsを削除
   */
  export function removeRobots(): void {
    const meta = document.querySelector('meta[name=\'robots\']');
    if (meta) {
      meta.remove();
    }
  }

  /**
   * OGP の設定
   *
   * @export
   * @param {{ property: string, content: string }} ogp
   */
  export function setOgp(ogp: { property: string, content: string }): void {
    let meta = document.querySelector(`meta[property='og:${ogp.property}']`);
    if (!meta) {
      meta = document.createElement('meta');
      document.head.appendChild(meta);
    }
    meta.setAttribute('property', `og:${ogp.property}`);
    meta.setAttribute('content', ogp.content);
  }

  /**
   * Twitter OGP の設定
   *
   * @export
   * @param {{ name: string, content: string }} ogp
   */
  export function setTwitterOgp(ogp: { name: string, content: string }): void {
    let meta = document.querySelector(`meta[name='twitter:${ogp.name}']`);
    if (!meta) {
      meta = document.createElement('meta');
      document.head.appendChild(meta);
    }
    meta.setAttribute('name', `twitter:${ogp.name}`);
    meta.setAttribute('content', ogp.content);
  }

  /**
   * カルモマガジンポップアップの非表示設定
   */
  export function setNoMagazinePopup(): void {
    if (window.localStorage) {
      try {
        // ポップアップ非表示フラグ格納
        window.localStorage.setItem(CARMO_CONST.MAGAZINE.NO_POPUP_LOCAL_STORAGE_KEY, 'true');
      } catch (e) {}
    }
  }

  /**
   * 消費税計算
   */
  export function calcTAX(arg?: number): number {
    const tax = CARMO_CONST.PRICE.TAX;
    if (arg) {
      return (arg < 0) ? Math.ceil(arg * tax) : Math.floor(arg * tax);
    }
    // undefined時は0
    return 0;
  }

  /**
   * 指定位置までスムーススクロール
   * @param id
   */
  export function scrollToId(id: string, margin?: number): void {
    // 画面の変更を考慮して気持ち遅らせる
    setTimeout(() => {
      const target: HTMLElement | null = document.getElementById(id);
      if (target) {
        window.scrollTo({
          top:
            window.scrollY + target.getBoundingClientRect().top - (margin || 0),
          behavior: 'smooth',
        });
      }
    }, 100);
  }
}
export default Util;
